"use client";

import { useEffect } from "react";
import toast, { ToastBar, Toaster, useToasterStore } from "react-hot-toast";

const TOAST_LIMIT = 5;
const TOAST_DURATION = 5000;

export default function AppToaster() {
  const { toasts } = useToasterStore();

  useEffect(() => {
    const active = toasts.filter(t => t.visible && !t.dismissed);
    if (active.length <= TOAST_LIMIT) return;
    const sorted = [...active].sort((a, b) => a.createdAt - b.createdAt);

    const overflow = sorted.slice(TOAST_LIMIT);
    overflow.forEach(t => toast.remove(t.id));
  }, [toasts]);

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{ duration: 5000 }}
      >
        {t => {
          const duration = typeof t.duration === "number" ? t.duration : 5000;
          const showProgress = Number.isFinite(duration) && duration > 0 && t.type !== "loading";

          return (
            <ToastBar
              toast={t}
              style={{ background: "transparent", boxShadow: "none" }}
            >
              {({ icon, message }) => (
                <div className="rt-toast relative overflow-hidden rounded-lg bg-white shadow-md ring-1 ring-black/5">
                  <div className="flex items-center gap-2 px-1 py-1">
                    {icon}
                    <div className="text-md leading-snug text-slate-900">{message}</div>
                  </div>

                  {showProgress && (
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[2px] bg-sky-200/40">
                      <div
                        key={t.id}
                        className="toast-progress h-full origin-left bg-sky-300"
                        style={{
                          transform: "scaleX(0)",
                          animation: `toast-progress ${duration}ms linear forwards`
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </ToastBar>
          );
        }}
      </Toaster>
      <style
        jsx
        global
      >
        {`
          @keyframes toast-progress {
            from {
              transform: scaleX(0);
            }
            to {
              transform: scaleX(1);
            }
          }

          .rt-toast:hover .toast-progress {
            animation-play-state: paused;
          }
        `}
      </style>
    </>
  );
}
